import { useEffect, useState } from 'react';
import {
  COLOR_ESTADO_FACTURA,
  ETIQUETA_ESTADO_FACTURA,
  formatearMonedaArs,
  type FacturaDTO,
} from '@ausentia/shared';
import { abrirPdf, api, ErrorApi } from '../api/cliente.js';

/** Facturas que el operador (cliente) le emite a la empresa. Solo lectura (ADR-0010). */
export function FacturasPortal() {
  const [facturas, setFacturas] = useState<FacturaDTO[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get<FacturaDTO[]>('/api/portal/facturas')
      .then(setFacturas)
      .catch((err) => setError(err instanceof ErrorApi ? err.message : String(err)));
  }, []);

  async function verPdf(id: string) {
    try {
      await abrirPdf(`/api/portal/facturas/${id}/pdf`);
    } catch (err) {
      alert(err instanceof ErrorApi ? err.message : String(err));
    }
  }

  return (
    <>
      <h2>Facturas recibidas</h2>
      <p className="muted">
        Comprobantes que el servicio de control médico le emite a la empresa por las visitas del
        período. El acceso a cada PDF queda asentado en la bitácora de auditoría.
      </p>

      {error && <div className="error-box">{error}</div>}
      {facturas === null && <div className="cargando">Cargando…</div>}
      {facturas && facturas.length === 0 && <p className="muted">Todavía no recibiste facturas.</p>}

      {facturas && facturas.length > 0 && (
        <table className="tabla">
          <thead>
            <tr>
              <th>Número</th>
              <th>Período</th>
              <th>Visitas</th>
              <th>Total</th>
              <th>Estado</th>
              <th>Documento</th>
            </tr>
          </thead>
          <tbody>
            {facturas.map((f) => (
              <tr key={f.id}>
                <td><span className="mini" style={{ fontFamily: 'monospace' }}>{f.numero}</span></td>
                <td className="mini">{f.periodo.desde} → {f.periodo.hasta}</td>
                <td>{f.visitas}</td>
                <td>{formatearMonedaArs(f.totalCentavos)}</td>
                <td><span className={`insignia ${COLOR_ESTADO_FACTURA[f.estado]}`}>{ETIQUETA_ESTADO_FACTURA[f.estado]}</span></td>
                <td>
                  <button className="secundario" style={{ width: 'auto' }} onClick={() => void verPdf(f.id)}>
                    PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
